import React, { useRef, useState } from 'react'
import '../styles/timeshare-details.css'
import { GetPostById, GetReviewByResortId, UploadReview, DeleteReview} from '../services/post.service'
import { Container, Row, Col, Form, ListGroup } from 'reactstrap'
import { useParams, useNavigate } from 'react-router-dom'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import Divider from '@mui/joy/Divider';
import Button from '@mui/material/Button';
import IconButton from '@mui/joy/IconButton';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ModalClose from '@mui/joy/ModalClose';
import { DialogActions, DialogContent, DialogTitle } from '@mui/joy';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { convertDate, convertDateTime } from '../utils/date'
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css"
import convertImageArray from '../utils/convertImageArray'
import { Box } from '@mui/material';
import { useSelector } from "react-redux";
import { useSnackbar } from 'notistack';
import { calculateAvgReviews } from '../utils/reviews'
import Rating from '@mui/material/Rating';
import ReadMoreArea from '@foxeian/react-read-more'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ShowerIcon from '@mui/icons-material/Shower';
import KitchenIcon from '@mui/icons-material/Kitchen';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import { Dropdown, Typography } from '@mui/joy'

const buttonStyle = {
    color: "DarkCyan",
    textDecoration: "none",
    // Add any other CSS styles as needed
};

const TimeShareDetails = () => {
    const user = useSelector((state) => state?.auth?.user);
    const { id } = useParams();
    const navigate = useNavigate();
    const reviewMsgRef = useRef('');
    const [post, setPost] = useState(null);
    const [rating, setRating] = useState(0);
    const [isReviewed, setIsReviewed] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [reviews, setReviews] = useState([]);
    const { enqueueSnackbar } = useSnackbar();

    React.useEffect(() => {
        GetPostById(id)
            .then((data) => {
                console.log(data);
                setPost(data);
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response.status)
                }
                else console.error("Cannot get data from server!")
            });
    }, []);
    React.useEffect(() => {
        // Check if user is logged in and show snackbar
        if (post) {
            getReviews();
        }
    }, [post]);

    const getReviews = async () => {
        console.log(post?.resortId?._id)
        const data = await GetReviewByResortId(post?.resortId?._id);
        data.forEach(review => {
            if (review.userId._id === user._id) {
                setIsReviewed(true);
            }
        });
        setReviews(data);
    }
    const deleteReview = async (id) => {
        try {
            await DeleteReview(id);
            enqueueSnackbar("Delete successfully", { variant: "success" });
            
            await getReviews();
            setIsReviewed(false);
            setOpenDelete(false);
        }
        catch (error) {
            enqueueSnackbar(`${error.message}`, { variant: "error" });
        }
    }
    //destructure properties from tour object
    //const { photo, title, desc, price, address, reviews, city, distance, maxGroupSize, time } = tour

    //format date
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    //submit request to server
    const submitHandler = async (e) => {
        try {
            e.preventDefault()
            if (rating) {
                const reviewText = reviewMsgRef.current.value;
                await UploadReview({
                    resortId: post?.resortId?._id,
                    star: rating,
                    description: reviewText,
                })
                await getReviews();
                reviewMsgRef.current.value = ""; // Clear input field
                setRating(0); // Reset rating state if needed
            }
            else enqueueSnackbar(`Star rating is required!`, { variant: "error" });
        }
        catch (error) {
            enqueueSnackbar(`${error.message}`, { variant: "error" });
        }
    }

    return <>
        <Header />
        <section>
            <Container>
                <Row>
                    {/* {(user?._id === post?.current_owner?._id) &&
                        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                            <MuiAlert onClose={handleCloseSnackbar} severity="error" sx={{ width: '60%' }}>
                                CAN'T RENT/EXCHANGE ON YOUR TIMESHARE
                            </MuiAlert>
                        </Snackbar>} */}
                    <Col lg='12'>
                        <div className="tour__content">
                            <Row>
                                <Col lg='6'>
                                    {post && <ImageGallery items={convertImageArray([...post.images, ...post.resortId.image_urls])} showPlayButton={false} />}
                                </Col>
                                <Col lg='6'>
                                    <div className='tour__info'>
                                        <Box sx={{ color: 'white', float: 'right', textAlign: 'center', backgroundColor: 'gray', paddingRight: '15px', paddingLeft: '15px', width: 'fit-content', borderRadius: '5px' }}>
                                            {(post?.is_bookable === false) ? 'SOLD' : ''}
                                        </Box>
                                        <h2>{post?.resortId.name}</h2>
                                        <div className='d-flex align-items-center gap-5'>
                                            <span className='d-flex align-items-center gap-1'>
                                                <span className='tour__rating d-flex align-items-center gap-1'>
                                                    <i class="ri-star-s-fill" style={{ 'color': "var(--secondary-color)" }}></i>
                                                    {calculateAvgReviews(reviews)}
                                                    {reviews?.length <= 0 ? 'Not yet rated' : <span>({reviews?.length})</span>}
                                                </span>
                                            </span>
                                            <span>
                                                <i class="ri-map-pin-line"></i> {post?.resortId.location}
                                            </span>
                                            <div>
                                                {/* <Renting tour={tour} avgRating={avgRating} /> */}
                                            </div>
                                        </div>
                                        <div className='tour__extra-details'>
                                            <span>
                                                <LocationOnIcon />{post?.resortId.location}
                                            </span>
                                            <span>
                                                <AttachMoneyIcon />{post?.price}
                                            </span>
                                            <span>
                                                <AccessTimeFilledIcon /> {convertDate(post?.start_date)} - {convertDate(post?.end_date)}
                                            </span>
                                        </div>
                                        <div>
                                            <h5>Description</h5>
                                            <p><ReadMoreArea wordsLimit={250} expandLabel="Read more »" buttonStyle={buttonStyle}>
                                                {post?.resortId.description}
                                            </ReadMoreArea></p>
                                        </div>
                                        <div>
                                            <h5>Room details</h5>
                                            <div className="d-lg-flex">
                                                <div className="col-lg-4 col-12">
                                                    <img src={post?.unitId.image} />
                                                </div>
                                                <div className="col-lg-8 col-12 px-lg-4">
                                                    <h6>{post?.unitId.name}</h6>
                                                    <div className="d-flex align-items-center">
                                                        <PeopleAltIcon />
                                                        <Typography sx={{ mx: 1 }}>Sleep {post?.unitId.sleeps}</Typography>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <ShowerIcon />
                                                        <Typography sx={{ mx: 1 }}>{post?.unitId.bathrooms} Bathrooms</Typography>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <KitchenIcon />
                                                        <Typography sx={{ mx: 1 }}>{post?.unitId.kitchenType} kitchen</Typography>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: '5px', marginTop: 10, marginBottom: 10 }}>
                                            <img style={{ borderRadius: "50%", margin: 0, width: 40, height: 40 }} src={post?.current_owner?.profilePicture} />
                                            <p style={{ margin: 0 }}>Post by: {post?.current_owner?.username}</p>
                                        </div>
                                        <>
                                            <div className="text-center" style={{ display: "flex", alignItems: "center", gap: '5px' }}>
                                                {user?._id === post?.current_owner?._id ? (
                                                    <>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            size="large"
                                                            onClick={() => navigate(`/me/my-timeshares/timeshares-list/${id}`)}
                                                        >
                                                            Manage
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        {post?.is_bookable === true && post?.type === 'rental' && (
                                                            <Button
                                                                variant="contained"
                                                                color="success"
                                                                size="large"
                                                                onClick={() => { navigate(`/timeshare/${post?._id}/book`) }}
                                                            >
                                                                Rent Now
                                                            </Button>
                                                        )}
                                                        {post?.is_bookable === true && post?.type === 'exchange' && (
                                                            <Button
                                                                variant="contained"
                                                                color="error"
                                                                size="large"
                                                                onClick={() => { navigate(`/timeshare/${post?._id}/exchange`) }}
                                                            >
                                                                Request to exchange
                                                            </Button>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </>

                                    </div>
                                </Col>
                            </Row>
                            {/*===========tour review section first========== */}
                            <div className='tour__reviews mt-4'>
                                <h4>Reviews ({reviews?.length} reviews)</h4>
                                {(user && !isReviewed) && (
                                    <Box>
                                        <Form onSubmit={submitHandler}>
                                            <Rating
                                                name="simple-controlled"
                                                size='large'
                                                value={rating}
                                                onChange={(event, newValue) => {
                                                    setRating(newValue);
                                                }}
                                            />
                                            <div className="review__input">
                                                <input
                                                    type="text"
                                                    name="description"
                                                    ref={reviewMsgRef}
                                                    placeholder='Share your thoughts'
                                                    required />
                                                <button className='btn primary__btn text-white'
                                                    type='submit'>
                                                    Submit
                                                </button>
                                            </div>
                                        </Form>
                                    </Box>
                                )}
                                {!user && (
                                    <Typography>Login to post reviews</Typography>
                                )}
                                <ListGroup className='user__reviews'>
                                    {
                                        reviews?.map(review => (
                                            <div className="review__item">
                                                <img src={review.userId.profilePicture} alt="" />
                                                <div className="w-100">
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div>
                                                            <div className="d-flex align-items-center">
                                                                <h5>{review?.userId?.username}</h5>
                                                                {(user && (user._id === review.userId._id)) && (
                                                                    //     <Button
                                                                    //     sx={{mx: 1}}
                                                                    //     variant="contained"
                                                                    //     color="error"
                                                                    //     size="small"
                                                                    //     onClick={() => { navigate(`/timeshare/${post?._id}/book`) }}
                                                                    // >
                                                                    //     Delete
                                                                    // </Button>
                                                                    <Box sx={{mx: 1}}>
                                                                    <Dropdown>
                                                                        <MenuButton
                                                                            slots={{ root: IconButton }}
                                                                            slotProps={{ root: { variant: 'plain', color: 'neutral', size: 'sm' } }}
                                                                        >
                                                                            <MoreHorizRoundedIcon />
                                                                        </MenuButton>
                                                                        <Menu size="sm" sx={{ minWidth: 140 }}>
                                                                            <MenuItem color="danger" onClick={() => {
                                                                                setOpenDelete(true);
                                                                            }}>Delete</MenuItem>
                                                                        </Menu>
                                                                    </Dropdown>
                                                                    </Box>
                                                                )}
                                                                <Modal open={openDelete} onClose={() => setOpenDelete(false)}>
                                                                    <ModalDialog variant="outlined" role="alertdialog">
                                                                        <DialogTitle>
                                                                        <WarningRoundedIcon />
                                                                        Confirmation
                                                                        </DialogTitle>
                                                                        <Divider />
                                                                        <DialogContent>
                                                                        Are you sure you want to delete your review?
                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                        <Button variant="solid" color="warning" onClick={() => deleteReview(review._id)}>
                                                                            Yes
                                                                        </Button>
                                                                        <Button variant="plain" color="neutral" onClick={() => setOpenDelete(false)}>
                                                                            No
                                                                        </Button>
                                                                        </DialogActions>
                                                                    </ModalDialog>
                                                                </Modal>
                                                            </div>
                                                            <p>{convertDateTime(review?.timestamp)}</p>
                                                        </div>
                                                        <span className='d-flex align-items-center'>
                                                            <Rating name="read-only" value={review.star} readOnly />
                                                        </span>
                                                    </div>
                                                    <h6>{review.description}</h6>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </ListGroup>
                            </div>
                        </div>
                    </Col>
                    {/* <Col lg='4'>
                        <Renting tour={tour} avgRating={avgRating} />
                    </Col> */}
                </Row>
            </Container>
        </section>
        <Footer />
    </>
}

export default TimeShareDetails